export default [
  {
    path: '/teams',
    name: 'teams-list',
    component: () => import('@/views/teams/pages/list.vue'),
    meta: {
      resource: 'teams',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Teams',
    },
  },
  {
    path: '/teams/levels',
    name: 'levels-list',
    component: () => import('@/views/teams/pages/Levels.vue'),
    meta: {
      resource: 'teams',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Teams Levels',
    },
  },
  {
    path: '/teams/reasons-tabs',
    name: 'teams-reasons-tabs',
    component: () => import('@/views/teams/pages/ReasonsTabs.vue'),
    meta: {
      resource: 'teams',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Reasons',
    },
  },
  // {
  //   path: '/teams/leave-reasons',
  //   name: 'leave-reasons-list',
  //   component: () => import('@/views/teams/pages/LeaveReasons.vue'),
  //   meta: {
  //     resource: 'teams',
  //     action: 'read',
  //     requiresAuth: true,
  //     pageTitle: 'Teams Leave Reasons',
  //   },
  // },
  // {
  //   path: '/teams/delete-reasons',
  //   name: 'delete-reasons-list',
  //   component: () => import('@/views/teams/pages/DeleteReasons.vue'),
  //   meta: {
  //     resource: 'teams',
  //     action: 'read',
  //     requiresAuth: true,
  //     pageTitle: 'Teams Delete Reasons',
  //   },
  // },
  {
    path: '/teams/:id',
    name: 'view-team-details',
    component: () => import('@/views/teams/pages/TeamDetails.vue'),
    meta: {
      resource: 'teams',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Team Details',
      breadcrumb: [
        {
          text: 'Teams List',
          to: '/teams',
        },
      ],
    },
  },
  {
    path: '/teams/levels/view-details/:id',
    name: 'level-details',
    component: () => import('@/views/teams/pages/LevelDetails.vue'),
    meta: {
      resource: 'teams',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Level Details',
      breadcrumb: [
        {
          text: 'Levels List',
          to: '/teams/levels',
        },
      ],
    },
  },
]
